/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import AdminBreadcrumb from '../../../../client/js/components/breadcrumb/AdminBreadcrumb'
import { FormattedMessage } from 'react-intl'
import { ReactNode } from 'react'
import { getEstateLink, getEstateListLink } from '../../lib/links/estateLinks'
import AnchorLink from '../../../../client/js/components/AnchorLink'
import { Divider } from '@mantine/core'
import BreadcrumbCard from '../../../../client/js/components/breadcrumb/BreadcrumbCard'
import EstateTabs from './EstateTabs'

export type EstateBreadcrumbProps = {
  estate?: Partial<Estate>,
  title: ReactNode
}

function EstateBreadcrumb (props: EstateBreadcrumbProps) {
  const { estate, title } = props
  return (
    <BreadcrumbCard>
      <AdminBreadcrumb>
        <AnchorLink to={getEstateListLink()}>
          <FormattedMessage
            id="estates"
            defaultMessage="Biens"
          />
        </AnchorLink>

        {estate?.id != null
          ? <AnchorLink to={getEstateLink(estate.id)}>
            {estate.reference}
          </AnchorLink>
          : null}

        <span>{title}</span>
      </AdminBreadcrumb>

      {estate?.id > 0
        ? <>
          <Divider my="xs" />
          <EstateTabs estateId={estate.id} />
        </>
        : null}
    </BreadcrumbCard>
  )
}

export default EstateBreadcrumb
